import m from 'mithril'

export default {
  view(vnode) {
    return (
      <div className="pano-overlay">
        <p>{vnode.attrs.scene.title}</p>
        <p>{vnode.attrs.scene.subtitle}</p>
      </div>
    )
  }
}
